// Pure route matchers for the nav chrome. Kept out of the SFC so both the
// component and its unit test import the same logic (script-setup can't export).

// The mobile "Library" tab points at /movies but represents the whole VOD
// section, so it must light up on the Movies grid, the Series grid, AND a
// Series detail page (/series/:id). One canonical matcher (CLAUDE.md "one
// resolver across every layer") avoids the dual-meaning-prop trap of
// re-deriving this per consumer.
export function isLibraryActive(path: string): boolean {
    return (
        path === '/movies'
        || path.startsWith('/movies/')
        || path === '/series'
        || path.startsWith('/series/')
    );
}
